import { CreateApplicationActions } from "./local-components/create-application-actions";
import { CreateApplicationStepContent } from "./local-components/create-application-step-content";
import { CreateApplicationStepTitle } from "./local-components/create-application-step-title";
import { CreateApplicationStepper } from "./local-components/create-application-stepper";
import { GoBackButton } from "./local-components/go-back-button";

import { Navigate } from "@tanstack/react-router";

import { useClientType } from "../../shared/hooks/use-client-type";
import { useUserRoles } from "../../shared/hooks/use-user-roles";
import { CreateApplicationDictionariesProvider, useCreateApplicationDictionariesContext } from "./create-application-dictionaries-context";
import { PageStoreProvider } from "./create-application-page.lib";
import { useInitDraft } from "./hooks/use-init-draft";

const CreateApplicationPageSkeleton = () => (
  <main className="flex min-h-0 w-full flex-1 flex-col overflow-hidden">
    <div className="min-h-0 flex-1 overflow-y-auto px-8 pt-6 [overflow-anchor:none]">
      <div className="mx-auto flex w-full max-w-[72.5rem] flex-col gap-8">
        <div className="skeleton h-8 w-full" />
        <div className="skeleton h-8 w-full" />
        <div className="skeleton h-10 w-full" />
        <div className="skeleton h-64 w-full" />
      </div>
    </div>
    <div className="px-8 pb-6 pt-2">
      <div className="skeleton mx-auto h-12 w-full max-w-[72.5rem]" />
    </div>
  </main>
);

const CreateApplicationPageContent = () => {
  const { isInitializing } = useInitDraft();
  const { isLoading: isDictionariesLoading } = useCreateApplicationDictionariesContext();

  if (isInitializing || isDictionariesLoading) {
    return <CreateApplicationPageSkeleton />;
  }

  return (
    <main className="flex min-h-0 w-full flex-1 flex-col overflow-hidden">
      <div data-create-application-scroll-root className="min-h-0 flex-1 overflow-y-auto px-8 pt-6 [overflow-anchor:none]">
        <div className="mx-auto flex w-full max-w-[72.5rem] flex-col gap-8 pb-8">
          <GoBackButton />
          <CreateApplicationStepper />
          <CreateApplicationStepTitle />
          <CreateApplicationStepContent />
        </div>
      </div>
      <div className="bg-neutrals-99 shrink-0 px-8 pb-6 pt-2">
        <CreateApplicationActions className="mx-auto w-full max-w-[72.5rem]" />
      </div>
    </main>
  );
};

const CreateApplicationPage = () => {
  const clientType = useClientType();
  const roles = useUserRoles();

  if (clientType !== "external" || !roles.isExternalApplicant) {
    return <Navigate to="/" />;
  }

  return (
    <PageStoreProvider>
      <CreateApplicationDictionariesProvider>
        <CreateApplicationPageContent />
      </CreateApplicationDictionariesProvider>
    </PageStoreProvider>
  );
};

export default CreateApplicationPage;
